$(document).ready(function () {
const currentUrl = window.location.href;
  // Remove 'active' from all links, then add to the matching one
  $(".option_link").each(function () {
    if (this.href === currentUrl) {
      $(this).parents('.option_value').addClass("active");
    }
  });

  setTimeout(function () {
    if ($(".samples__list").length >= 1) {
      $(".error_too_much").show();
    }
  }, 1000);

  $(document).on("click", ".header__icon--cart", function (event) {
    event.preventDefault();
    $("cart-drawer.drawer").addClass("active");
  });

  checkCartForItems();
  product_slick_slider();

  $(document).on("click", ".mobile-close-wrap", function () {
    $(this).closest(".menu-drawer-container").removeClass("menu-opening");
    $(this)
      .parents(".menu-drawer-container")
      .find(".header__icon--menu")
      .attr("aria-expanded", false);
    $("body").removeClass("overflow-hidden-tablet");
  });

  $(".header__menu-item").hover(
    function () {
      // Mouse enters: Add attribute
      $(this).parents("details").attr("open", "true");
      $(this).parents("details").addClass("submenu-opened");
      $(this).attr("aria-expanded", "true");
    },
    function () {
      // Mouse leaves: Remove attribute
      // $(this).parents('.mega-menu').removeAttr('open');
      $(this).parents("details").removeClass("submenu-opened");
      $(this).attr("aria-expanded", "true");
    }
  );

  $(".header__menu-item, .mega-menu__content").hover(
    function () {
      $(this).parents(".header-wrapper").addClass("menu-opened");
    },
    function () {
      $(this).parents(".header-wrapper").removeClass("menu-opened");
    }
  );

  if ($(window).width() > 767) {
    $(".video_slide").slick({
      draggable: true,
      adaptiveHeight: true,
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="slick-next pull-right">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
        '<g id="prev" transform="translate(2634 -471) rotate(90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
        "</svg></button>",
      nextArrow:
        '<button type="button" class="slick-prev pull-left">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
        '<g id="next" transform="translate(-2609 485.97) rotate(-90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
        "</svg>" +
        "</button>",
      dots: true,
      infinite: true,
    });
  } else {
    $(".video_slide").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: false,

      responsive: [
        {
          breakpoint: 749,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    });
    /* The awards row is no longer a slick carousel. It is two CSS marquees
       running in opposite directions (see sections/image-with-tooltip.liquid),
       and slick was wrapping it in its own track and transform, which fought
       the animation. The markup class was renamed to .iwtt--track so this
       cannot silently reattach. */
  }
  $(".product--instructions_image-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    dots: true,
    prevArrow:
      '<button type="button" class="slick-next pull-right">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="prev" transform="translate(2634 -471) rotate(90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg></button>",
    nextArrow:
      '<button type="button" class="slick-prev pull-left">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="next" transform="translate(-2609 485.97) rotate(-90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg>" +
      "</button>",
  });
  // Cache selectors
  const $window = $(window);
  const $vcSlides = $(".vc-slide");
  const $vcContentWraps = $(".vc-content-wrap");
  const $productInstructionsLinks = $(".product_instructions-link");
  const $tabLinks = $(".tab_link");
  const $productDimensionLinks = $(".product_dimension-link");
  const $productStructureLineks = $(".product_structure-link");
  // Scroll event optimization
  $(window).on("scroll", function () {
    var mostVisible = null;
    var maxVisibleArea = 0;
    $(".vc-content-wrap").each(function () {
      const $this = $(this);
      const elementTop = $this.offset().top;
      const elementBottom = elementTop + $this.outerHeight();
      const viewportTop = $(window).scrollTop();
      const viewportBottom = viewportTop + $(window).height();
      const visibleTop = Math.max(elementTop, viewportTop);
      const visibleBottom = Math.min(elementBottom, viewportBottom);
      const visibleArea = Math.max(0, visibleBottom - visibleTop);

      // Track the most visible .vc-content-wrap based on the area visible in the viewport
      if (visibleArea > maxVisibleArea) {
        maxVisibleArea = visibleArea;
        mostVisible = $this;
      }
    });
    if (mostVisible) {
      // Reset all active classes
      $(".vc-content-wrap").removeClass("is-active");
      $(".vc-imges").removeClass("is-active");
      mostVisible.addClass("is-active");
      const targetId = mostVisible.data("target");
      $("#" + targetId).addClass("is-active");
    }
  });

  handleLinkActivation($tabLinks, $(".product-tab_content"));
  handleLinkActivation($productDimensionLinks, $(".product--dimensions_image"));
  handleLinkActivation($productStructureLineks, $(".product--structure_image"));

  $(".product_instructions-link").on("click", function () {
    const $this = $(this);
    const targetId = $this.attr("id");
    $(".product_instructions-link").removeClass("active");
    $this.addClass("active");
    $(".product--instructions_image").hide().removeClass("active");
    $(`.product--instructions_image[data-target="${targetId}"]`)
      .show()
      .addClass("active");
    $(".product--instructions_image").slick("refresh");
  });

  $(".current_option").hover(function () {
    $(".mob_sort-by-content").show();
  });

  $(".faq-acc__link").click(function () {
    var target = $(this).attr("data-target");
    $("html, body").animate(
      {
        scrollTop: $("#" + target).offset().top,
      },
      500
    );
    return false;
  });
  $(".faq_tab--link").click(function () {
    $(this).toggleClass("active");
    var $content = $(this).next(".faq_tab-content");
    $content.slideToggle();
    $(".faq_tab-content").not($content).slideUp(); // Close all other contents
    $(".faq_tab--link").not(this).removeClass("active"); // Remove active class from other tabs
  });

  $(".cm__content-title").click(function () {
    $(this).toggleClass("active");
    var $content = $(this)
      .parents(".cm__content--item-wrap")
      .find(".cm__content--item-bottom-pdf-wrapper");
    $content.slideToggle();
    // These panels are independent -- the "close all others" line below has
    // been off for a while, and every group now starts open. Clearing .active
    // from the other titles therefore desynced them: their panels stayed open
    // while their headers showed as closed. Each header tracks its own panel.
    // $('.cm__content--item-bottom-pdf-wrapper').not($content).slideUp();
  });

  var checkedValue = localStorage.getItem("selectedRadio");
  const toggleInput = document.querySelector('.toggle__input');
  let toggleInputVisible = false;
  if (toggleInput && toggleInput.offsetHeight > 0 && toggleInput.offsetWidth > 0) {
    toggleInputVisible = true;
  }
  if (checkedValue && toggleInputVisible) {
    $(".toggle__input[value='" + checkedValue + "']").prop("checked", true);
    toggleCustomAttrWrapElements();
  }

  $(".toggle__input").on("change", function () {
    var selectedValue = $(this).val();
    if ($(this).prop("checked")) {
      localStorage.setItem("selectedRadio", selectedValue);
      toggleCustomAttrWrapElements();
      autoRedirectFirstAvailablePillOption();
    } else {
      toggleCustomAttrWrapElements();
      autoRedirectFirstAvailablePillOption();
      localStorage.removeItem("selectedRadio");
      $('.custom_attr_wrap').show();
    }
  });

  $(document).on("change", "#select__id", function () {
    var $el = $(this),
      $selected = $el.find(":selected"),
      id = $selected.attr("data-id"),
      $wrap = $("#variant_picker__custom--main"),
      form_id = $wrap.attr("data-form_id"),
      available = $selected.attr("data-available") === "true",
      v = $selected.attr("data-variant"),
      vj = v ? JSON.parse(v) : null;

    if (!v) {
      return;
    }
    $("#" + form_id)
      .find('[name="id"]')
      .val(id);
    toggleAddButton(form_id, !available, window.variantStrings.soldOut);
  });

  $(document).on(
    "change",
    ".variant_picker__custom .product-form__input input",
    function () {
      var $el = $(this),
        $wrap = $el.closest(".variant_picker__custom"),
        checked_arr = [],
        $hSelect = $("#select__id");
      $wrap.find(".product-form__input").each(function () {
        let $e = $(this),
          $input = $e.find("input:checked"),
          val = $input.val();
        checked_arr.push(val);
      });
      let v_title = checked_arr.join(" / ");
      $hSelect.val(v_title).change();
    }
  );

  $(document).on("change", ".vpc_swatch_input", function () {
    trigger_select("input");

    // If toggle is on, apply filtering
    if ($('.toggle__input').prop('checked')) {
      toggleCustomAttrWrapElements();
    }
  });

  $(document).on("change", ".vpc_swatch_select", function () {
    trigger_select("select");

    // If toggle is on, apply filtering
    if ($('.toggle__input').prop('checked')) {
      toggleCustomAttrWrapElements();
    }
  });

  updateAddToCartDisabledState();
  toggleCustomAttrWrapElements();
}); //ready

function trigger_select(type = "input") {
  var options_len = $(".variant_picker__custom .product-form__input").length,
    opts = "",
    opt1 = "",
    opt2 = "",
    opt3 = "";
  if (type == "input") {
    opt1 = $('.variant_picker__custom [data-option="option1"] .vpc_swatch_input:checked').val();
    opt2 = $('.variant_picker__custom [data-option="option2"] .vpc_swatch_input:checked').val();
    opt3 = $('.variant_picker__custom [data-option="option3"] .vpc_swatch_input:checked').val();
  } else {
    opt1 = $('.variant_picker__custom [data-option="option1"] .vpc_swatch_select').val();
    opt2 = $('.variant_picker__custom [data-option="option2"] .vpc_swatch_select').val();
    opt3 = $('.variant_picker__custom [data-option="option3"] .vpc_swatch_select').val();
  }
  if (options_len == 1) {
    opts = opt1;
  } else if (options_len == 2) {
    opts = opt1 + " / " + opt2;
  } else if (options_len == 3) {
    opts = opt1 + " / " + opt2 + " / " + opt3;
  }
  $("#select__id").val(opts).change();
}

function toggleAddButton(form_id, disable = true, text) {
  let $form = form_id ? $(`#${form_id}`) : $();
  if (!$form.length) $form = $('form[data-type="add-to-cart-form"]:visible').first();

  if (!$form.length) return;

  let $btn = $form.find('[name="add"]').first();
  if (!$btn.length) return;

  const $btnText = $btn.find('span').first();

  if (disable) {
    $btn.prop('disabled', true)
        .attr('disabled', 'disabled')
        .attr('aria-disabled', 'true')
        .addClass('is-disabled');

    const finalText = text || (window.variantStrings && window.variantStrings.soldOut) || "Sold out";
    if ($btnText.length) $btnText.text(finalText);
    else $btn.text(finalText);

    $form.closest('section, .product, body')
        .find('.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options')
        .attr('disabled','disabled')
        .addClass('is-disabled')
        .css({pointerEvents:'none', opacity:0.5});
  } else {
    $btn.prop('disabled', false)
        .removeAttr('disabled')
        .attr('aria-disabled', 'false')
        .removeClass('is-disabled');

    if ($btnText.length) $btnText.text(window.variantStrings?.addToCart || 'Add to cart');
    else $btn.text(window.variantStrings?.addToCart || 'Add to cart');

    $form.closest('section, .product, body')
        .find('.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options')
        .removeAttr('disabled')
        .removeClass('is-disabled')
        .css({pointerEvents:'', opacity:''});
  }

}

function updateAddToCartDisabledState() {
  const form_id =
      $("#variant_picker__custom--main").attr("data-form_id") ||
      $('form[data-type="add-to-cart-form"]').first().attr('id');

  const toggleChecked = $('.toggle__input').prop('checked');

  const $colorGroup  = $(".product-form__input--swatch");
  const $coversGroup = $(".product-form__input--pill-covers");
  const $legsGroup   = $(".product-form__input--pill-legs");

  const hasAnyColor  = !$colorGroup.length  ? true :
      $colorGroup.find(".custom_attr_wrap[data-option-name='Boja'][data-avl='true']:visible").length > 0;

  const hasAnyCovers = !$coversGroup.length ? true :
      $coversGroup.find(".custom_attr_wrap[data-avl='true']:visible").length > 0;

  const hasAnyLegs   = !$legsGroup.length   ? true :
      $legsGroup.find(".custom_attr_wrap[data-avl='true']:visible").length > 0;

  const noAvailable = !hasAnyColor || !hasAnyCovers || !hasAnyLegs;

  if (toggleChecked && noAvailable) {
    setTimeout(function () {
      toggleAddButton(
          form_id,
          true,
          (window.variantStrings && window.variantStrings.soldOut) || "Sold out"
      );
    }, 50);
  } else {
    toggleAddButton(form_id, false);
  }
}

function toggleCustomAttrWrapElements() {
  const toggleChecked = $('.toggle__input').prop('checked');

  $(".stock-messages .no-color-options-message").hide();
  $(".stock-messages .out-of-stock-covers").hide();
  $(".stock-messages .out-of-stock-message").hide();
  $(".stock-messages .out-of-stock-legs").hide();
  $(".custom_attr_wrap").each(function () {
    const $el = $(this);
    const isAvailable = $el.attr("data-avl") === "true";
    const optionName = $el.attr("data-option-name")?.toLowerCase();

    $el.removeClass("material-out-of-stock");
    if (!toggleChecked) {
      $el.show();
      $('.stock-messages > .no-material-options-message').hide();
      $('.product-form__input--swatch').show();
      $('.product-form__input--pill-custom').show();

      return;
    }
    if (isAvailable) {
      $el.show();
    } else {
      /* The MATERIAL option is shown-but-struck when it is out of stock, every
         other option is hidden. The test used to be the Slovenian option name
         alone (`izberi material`), carried over unchanged when this theme was
         ported from SI -- and the HR option is called "Materijal", so the branch
         never ran and out-of-stock fabrics were HIDDEN here instead of marked
         (Magda 2026-09-03). Matched by stem now, so both stores and any future
         market that spells it "material/materijal/materiale" land in it. */
      if (optionName && (optionName.indexOf("materijal") !== -1 || optionName.indexOf("material") !== -1)) {
        $el.show().addClass("material-out-of-stock");
      } else {
        $el.hide();
      }
    }
  });

  // setTimeout(function () {
    // Auto select first color available for each swatch group
    $(".product-form__input--swatch").each(function () {
      const $group = $(this);
      const $selected = $group.find(".swatch-input__input:checked");
      const selectedIsVisible = $selected.length && $selected.is(":visible");

      if (selectedIsVisible) {
        return;
      }

      const $firstVisible = $group.find(".custom_attr_wrap[data-avl='true']:visible .swatch-input__input").first();
      const $firstWrap = $firstVisible.closest(".custom_attr_wrap");

      if ($firstVisible.length && $firstWrap.length) {
        const variantId = $firstWrap.data("variant-id");

        if (variantId && !isNaN(variantId)) {
          const currentUrl = new URL(window.location.href);
          const currentVariantId = currentUrl.searchParams.get("variant");

          if (currentVariantId !== variantId.toString()) {
            if (window._variantRedirectInProgress) return;
            window._variantRedirectInProgress = true;

            const newUrl = `${window.location.pathname}?variant=${variantId}`;
            window.location.href = newUrl;
            return false;
          }
          return false;
        }
      } else {
        $(".stock-messages .out-of-stock-message").hide();
        // $(".stock-messages .no-color-options-message").show();
        $group.hide();
        $group.find("legend [data-selected-value]").text("");
      }
    });

    // Now handle materials with no available colors and update any remaining labels
    hideMaterialsWithNoAvailableColors(toggleChecked);

    // Final check to ensure all labels are updated correctly
    $(".product-form__input--swatch").each(function() {
      const $group = $(this);
      const $selected = $group.find(".swatch-input__input:checked");

      if ($selected.length) {
        const labelSpan = $group.find("legend [data-selected-value]");
        if (labelSpan.length) {
          const currentLabel = labelSpan.text();
          const selectedValue = $selected.val();

          if (currentLabel !== selectedValue) {
            labelSpan.text(selectedValue);
          }
        }
      }
    });

  autoRedirectFirstAvailablePillOption();
  updateAddToCartDisabledState();
  // }, 10);
}
function autoRedirectFirstAvailablePillOption() {
  if (!$('.toggle__input').prop('checked')) return;

  ['.product-form__input--pill-covers', '.product-form__input--pill-legs'].forEach(function (groupSelector) {
    const $group = $(groupSelector);
    if (!$group.length) return;

    const $selected = $group.find('input[type="radio"]:checked');
    const $wrap = $selected.length ? $selected.closest('.custom_attr_wrap') : $();

    const selectedIsOK =
        $wrap.length && $wrap.is(':visible') && $wrap.attr('data-avl') === 'true';

    if (selectedIsOK) return;

    const $first = $group.find('.custom_attr_wrap[data-avl="true"]:visible').first();
    if (!$first.length) {
      updateAddToCartDisabledState();
      return;
    }

    const variantId = $first.data('variant-id');
    if (!variantId || isNaN(variantId)) return;

    const currentVariantId = new URL(window.location.href).searchParams.get('variant');
    if (String(currentVariantId) === String(variantId)) return;

    if (window._variantRedirectInProgress) return;
    window._variantRedirectInProgress = true;

    window.location.href = `${window.location.pathname}?variant=${variantId}`;
  });
}
// function autoSelectFirstVisibleOption3() {
//   $(".product-form__input--pill-covers").each(function () {
//     const $group = $(this);
//     const $visibleOptions = $group.find('.custom_attr_wrap[data-avl="true"]:visible');
//
//     const $selected = $group.find('input[type="radio"]:checked');
//     const selectedIsVisible = $selected.length && $selected.closest('.custom_attr_wrap').is(':visible');
//
//     if (selectedIsVisible) {
//       return;
//     }
//
//     if ($visibleOptions.length > 0) {
//       const $firstVisible = $visibleOptions.first();
//       const $radio = $firstVisible.find('input[type="radio"]');
//
//       if ($radio.length) {
//         $radio.prop('checked', true).trigger('change');
//       }
//     }
//   });
// }

function hideMaterialsWithNoAvailableColors(toggleChecked) {
  $(".stock-messages .no-color-options-message").hide();
  $(".stock-messages .out-of-stock-covers").hide();
  $(".stock-messages .out-of-stock-message").hide();
  $(".stock-messages .out-of-stock-legs").hide();
  $(".stock-messages .out-of-stock-selected-cover").hide();
  $(".stock-messages .out-of-stock-selected-legs").hide();

  let colorOutOfStock = false;
  let coverOutOfStock = false;
  let legsOutOfStock = false;

  let selectedCoverIsOutOfStock = false;
  let selectedLegsIsOutOfStock = false;

  // COLOR
  $(".product-form__input--swatch").each(function () {
    const $swatchGroup = $(this);
    const colorOptions = $swatchGroup.find(".custom_attr_wrap[data-option-name='Boja']");
    let hasAvailableColor = false;

    colorOptions.each(function () {
      const $option = $(this);
      const isAvailable = $option.attr("data-avl") === "true";
      if (isAvailable) {
        hasAvailableColor = true;
      }
    });

    if (!hasAvailableColor) {
      colorOutOfStock = true;

      // Ako toggle NIJE uključen, ne skrivaj swatch, samo prikaži poruku
      if (!toggleChecked) {
        $swatchGroup.show();
      } else {
        $swatchGroup.hide();
      }
    } else {
      $swatchGroup.show();
    }
  });

  // COVERS
  $(".product-form__input--pill-covers").each(function () {
    const $group = $(this);
    const coverOptions = $group.find(".custom_attr_wrap").filter(function () {
      const name = $(this).attr("data-option-name")?.toLowerCase();
      return name === "Navlaka" || name === "navlaka";
    });

    let hasAvailableCover = false;

    coverOptions.each(function () {
      const $option = $(this);
      const isAvailable = $option.attr("data-avl") === "true";
      if (!toggleChecked || isAvailable) {
        hasAvailableCover = true;
      }
    });

    if (!hasAvailableCover) {
      coverOutOfStock = true;
      $group.hide();
    } else {
      $group.show();
    }

    const $selected = $group.find("input[type='radio']:checked");
    const $wrap = $selected.closest(".custom_attr_wrap");

    if (
        $wrap.length &&
        $wrap.attr("data-avl") === "false" &&
        $wrap.is(":visible")
    ) {
      selectedCoverIsOutOfStock = true;
    }
  });

  // LEGS
  $(".product-form__input--pill-legs").each(function () {
    const $group = $(this);
    // The fieldset class is the locale-independent semantic marker. CasCais
    // can combine leg colour/height with a constant cover suffix in one option.
    const legsOptions = $group.find(".custom_attr_wrap");
    let hasAvailableLegs = false;

    legsOptions.each(function () {
      const $option = $(this);
      const isAvailable = $option.attr("data-avl") === "true";
      if (!toggleChecked || isAvailable) {
        hasAvailableLegs = true;
      }
    });

    if (!hasAvailableLegs) {
      legsOutOfStock = true;
      $group.hide();
    } else {
      $group.show();
    }

    const $selected = $group.find("input[type='radio']:checked");
    const $wrap = $selected.closest(".custom_attr_wrap");

    if (
        $wrap.length &&
        $wrap.attr("data-avl") === "false" &&
        $wrap.is(":visible")
    ) {
      selectedLegsIsOutOfStock = true;
    }
  });

  // Override outOfStock flags based on visibility
  if ($(".product-form__input--pill-covers .custom_attr_wrap:visible").length > 0) {
    coverOutOfStock = false;
  }

  if ($(".product-form__input--pill-legs .custom_attr_wrap:visible").length > 0) {
    legsOutOfStock = false;
  }

  const visibleAvailableColors = $(".product-form__input--swatch .custom_attr_wrap[data-option-name='Boja']")
      .filter(function () {
        return $(this).attr("data-avl") === "true" && $(this).is(":visible");
      });

  if (visibleAvailableColors.length > 0) {
    colorOutOfStock = false;
    $(".stock-messages .no-color-options-message").hide();
    $(".product-form__input--swatch").show();
  }

  // === FINAL MESSAGE LOGIC ===

  if (colorOutOfStock && (coverOutOfStock || legsOutOfStock)) {
    $(".stock-messages .no-variants-message").show();
  } else if (colorOutOfStock) {
    $(".stock-messages .no-color-options-message").show();
  } else if (coverOutOfStock) {
    $(".stock-messages .out-of-stock-covers").show();
  } else if (legsOutOfStock) {
    $(".stock-messages .out-of-stock-legs").show();
  } else {
    // Only show "selected X out of stock" if ALL options are not globally out of stock
    if (selectedCoverIsOutOfStock) {
      $(".stock-messages .out-of-stock-selected-cover").show();
    }
    if (selectedLegsIsOutOfStock) {
      $(".stock-messages .out-of-stock-selected-legs").show();
    }
  }
}


// Generalized function for handling tab/link activation
function handleLinkActivation($links, $content, dataAttribute) {
  $links.on("click", function () {
    const $this = $(this);
    const targetId = $this.attr("id");
    $links.removeClass("active");
    $this.addClass("active");
    // Hide all content and remove active class
    $content.hide().removeClass("active");
    // Show the target content and add active class
    $content.filter(`[data-target="${targetId}"]`).show().addClass("active");
    $(".product--instructions_image").slick("refresh");
  });
}

// Initialize the Slick Sliders
function product_slick_slider() {
  $(".product-slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    asNavFor: ".product-slider-nav",
    responsive: [
      {
        breakpoint: 500,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  $(".product-slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      '<button type="button" class="slick-next pull-right">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="prev" transform="translate(2634 -471) rotate(90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg></button>",
    nextArrow:
      '<button type="button" class="slick-prev pull-left">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="14.97" viewBox="0 0 25 14.97">' +
      '<g id="next" transform="translate(-2609 485.97) rotate(-90)"><rect id="Rectangle_104" data-name="Rectangle 104" width="2" height="25" rx="1" transform="translate(479.485 2634) rotate(180)" fill="#333"></rect><rect id="Rectangle_105" data-name="Rectangle 105" width="2" height="10" rx="1" transform="translate(478.899 2634) rotate(-135)" fill="#333"></rect><rect id="Rectangle_106" data-name="Rectangle 106" width="2" height="10" rx="1" transform="translate(479.485 2632.586) rotate(135)" fill="#333"></rect></g>' +
      "</svg>" +
      "</button>",
    vertical: false,
    infinite: false,
    asNavFor: ".product-slider-for",
    focusOnSelect: true,
  });
}

$(".product-slider-for").on("init", function (event, slick) {
  setTimeout(function () {
    filterSliders(
      $(".product-form__input--swatch input[type=radio]:checked").val()
    );
  }, 1000);
});

function filterSliders(var_place) {
  var $sliderFor = $(".product-slider-for"),
    $sliderNav = $(".product-slider-nav");

  if (
    $sliderFor.hasClass("slick-initialized") &&
    $sliderNav.hasClass("slick-initialized")
  ) {
    // First, unfilter all slides
    $sliderFor.slick("slickUnfilter");
    $sliderNav.slick("slickUnfilter");

    try {
      setTimeout(function () {
        $sliderFor.slick("slickFilter", "." + var_place);
        $sliderNav.slick("slickFilter", "." + var_place);
        $(".sslick__slider__media").removeClass("loading-gallery");
      }, 800);
    } catch (error) {}
  }
}

$(document).on("change", ".product-form__input--pill", function () {
  toggleCustomAttrWrapElements();

  $(".sslick__slider__media").addClass("loading-gallery");
  setTimeout(function () {
    // $(".swatch-input__input").eq(0).click();
    $(".product-slider-for").slick("refresh");
    $(".product-slider-nav").slick("refresh");
    $(".sslick__slider__media").removeClass("loading-gallery");
  }, 8000);
});

$(document).on("change", ".product-form__input", function () {
  // Call toggleCustomAttrWrapElements to ensure consistent behavior
  // This will handle selecting the first available color and updating the label
  toggleCustomAttrWrapElements();

  let variant = $(".swatch-input__input:checked").val();
  var $sliderFor = $(".product-slider-for"),
    $sliderNav = $(".product-slider-nav");
  $(".sslick__slider__media").addClass("loading-gallery");
  setTimeout(function () {
    $(".product-slider-for").slick("slickGoTo", 0); // Go to the first slide
    $(".thumbnail-list__item").each(function (index) {
      $(this).attr("data-slick-index", index);
    });
  }, 8000);

  if (
    $sliderFor.hasClass("slick-initialized") &&
    $sliderNav.hasClass("slick-initialized")
  ) {
    $sliderFor.slick("slickUnfilter");
    $sliderNav.slick("slickUnfilter");

    try {
      setTimeout(function () {
        $sliderFor.slick("slickFilter", "." + variant);
        $sliderNav.slick("slickFilter", "." + variant);
        $(".sslick__slider__media").removeClass("loading-gallery");
      }, 3000);
    } catch (error) {
      console.error("Error filtering:", error);
    }
  }

});

$(".product-slider-nav, .product-slider-for").on(
  "afterChange",
  function (event, slick, currentSlide, nextSlide) {
    var $el = $(event.target),
      $wrap = $el.closest(".product__media-wrapper"),
      $current = $el.find(".slick-current.slick-active"),
      index = $current.data("slick-index"),
      $main = $wrap.find(".product-slider-for"),
      $thumb = $wrap.find(".product-slider-nav");

    // Remove aria-current from all thumbnails
    $thumb.find(".thumbnail").removeAttr("aria-current");
    // Add aria-current to the current thumbnail
    $thumb
      .find(`[data-slick-index="${index}"] .thumbnail`)
      .attr("aria-current", "true");
  }
);
// ### Sample page Drawer Js ###

/* Make the whole swatch tile toggle the sample (David 2026-08-03: "when I click
   on the box of vzorec, it doesn't get added to cart properly").

   The tile markup (sections/colors-and-materials.liquid) is a plain <div> with
   a background image and an <input type="checkbox"> tucked in the corner -- no
   <label>, no wrapping control. So the ONLY clickable target was the ~16px
   checkbox itself. Clicking the swatch image, its title, or the "Naroči
   vzorec" label did nothing at all, which reads exactly like "it doesn't get
   added": the shopper clicks the obvious big target and nothing happens.

   Forwarding the click to the checkbox is enough -- .formulas_checkboxes
   already owns all the add/remove logic below, so this changes the hit area
   only, not the behaviour.

   The guard matters: a click that lands ON the checkbox already fires that
   handler natively, so forwarding it too would toggle twice and cancel out. */
$(document).on("click", ".cmcnt--item-prd", function (e) {
  var $cb = $(this).find(".formulas_checkboxes");
  if (!$cb.length) return;
  if ($(e.target).closest(".formulas_checkboxes").length) return;
  e.preventDefault();
  /* Just forward the click -- do NOT set .checked first. jQuery's
     .trigger("click") on a real checkbox performs the native toggle itself, so
     flipping the property beforehand toggles twice: the box lands back on its
     original state while the handler still runs and sees "checked", which
     added a SECOND copy of an already-added swatch (cart went 2 -> 3 on a
     click that should have removed one). */
  $cb.trigger("click");
});

/* Pointer affordance to match: the tile now behaves like a control, so it has
   to look like one. */
$(function () {
  var css = document.createElement("style");
  css.textContent =
    ".cmcnt--item-prd{cursor:pointer}" +
    ".cmcnt--item-prd:focus-within{outline:2px solid rgb(var(--color-foreground));outline-offset:2px}";
  document.head.appendChild(css);
});

$(document).on("click", ".formulas_checkboxes", function () {
  var $el = $(this),
    value = $el.val(),
    data_title = $el.attr("data-title"),
    image_src = $el.attr("data-src");

  // Get the current number of items in the list
  var itemCount = $(".samples__list").length;

  // Check if the checkbox is checked or unchecked
  if ($(this).prop("checked")) {
    if (itemCount < 5) {
      // Allow adding item only if fewer than 5 items are added
      // Slovenian, informal: this ran as hardcoded English on a Slovenian
      // page, so the label flipped to "Remove ?" on click (David 2026-07-31).
      $el.parents(".cmcnt--item-prd").find(".label_wrap").html("Ukloni");
      $el.parents(".prod_Checkbox").addClass("active-checkbox");

      // Create the new HTML element for the sample
      var newSampleHTML = `<div class="samples__list" data-id="${value}">
                                <div class="samples_list__samples_img">
                                    <img src="${image_src}" alt="${data_title}">
                                </div>
                                <div class="samples_list__samples_title">${data_title}</div>
                                <a href="#" class="remove_samples_from_list">x</a>
                              </div>`;

      // Append the new element to the list without removing previous items
      $(".sample_side-lists").append(newSampleHTML);

      /* Add to the CART on tick, not on a later bulk button (David 2026-08-03:
         "When you click on the sample it should add to cart"). The panel is now
         a receipt of what is already in the cart, not a staging area, which is
         what made the old flow read as two competing drawers. Cart-backed via
         the same module the global sample tray uses, so both surfaces share one
         source of truth. */
      if (window.FeydomSamples && typeof window.FeydomSamples.add === 'function') {
        window.FeydomSamples.add({
          variantId: value,
          title: data_title,
          material: $el.attr('data-material') || '',
          image: image_src,
          url: window.location.pathname
        }).catch(function (err) { console.error('sample add', err); });
      }
      /* Deliberately NO .show() here. toggleDrawerVisibility() at the end of
         this handler already decides whether the drawer should be open, and
         calling show() as well meant every add force-opened it a second time. */

      // Hide the error message if the item is added successfully
      $(".error_too_much").hide();
    } else {
      // If more than 5 items are being added, show error message
      $(".error_too_much").show();
      // Uncheck the checkbox
      $el.prop("checked", false);
    }
  } else {
    // Slovenian, informal (was hardcoded English "Order a sample").
    $el.parents(".cmcnt--item-prd").find(".label_wrap").html("Naruči uzorak");
    $el.parents(".prod_Checkbox").removeClass("active-checkbox");
    var sampleId = $(this).val(); // Use the checkbox value to find the corresponding sample
    $('.sample_side-lists .samples__list[data-id="' + sampleId + '"]').remove();
    /* Untick removes the line from the cart too, otherwise the panel and the
       cart drift apart the moment someone changes their mind. */
    if (window.FeydomSamples && typeof window.FeydomSamples.removeByMatch === 'function') {
      window.FeydomSamples.removeByMatch($el.attr('data-title') || '', $el.attr('data-material') || '');
    }

    // Hide the error message when item is removed
    $(".error_too_much").hide();
  }
  toggleDrawerVisibility();
});

// Optional: Handling the removal of an item from the list
$(document).on("click", ".remove_samples_from_list", function (e) {
  e.preventDefault();
  // Get the value of the removed sample's data-id
  var sampleId = $(this).closest(".samples__list").data("id");
  // Find and uncheck the corresponding checkbox based on the data-id
  $(".formulas_checkboxes").each(function () {
    if ($(this).val() == sampleId) {
      $(this).prop("checked", false); // Uncheck the checkbox
      $(this)
        .parents(".cmcnt--item-prd")
        .find(".label_wrap")
        .text("Naruči uzorak"); // Reset the label text
      $(this).parents(".prod_Checkbox").removeClass("active-checkbox");
    }
  });
  $(this).closest(".samples__list").remove();
  // Check if the sample_side-lists has items and hide the drawer if empty
  toggleDrawerVisibility();
});
// Function to toggle the visibility of the drawer based on the number of items
/* Once the shopper closes the sample drawer, adding another swatch must NOT
   yank it back open (David 2026-07-31: "I added 3 samples in side cart: side
   cart opened again... that's not ok"). Previously this ran after every
   checkbox click and force-showed the drawer whenever the list was non-empty,
   so the drawer reappeared on each of the 3 adds no matter how often it was
   dismissed. It now stays closed until the shopper reopens it, while the list
   behind it keeps updating. Emptying the list resets the flag, so the next
   fresh selection opens the drawer once, as it should. */
var sampleDrawerDismissed = false;

function syncSampleReopen() {
  /* The re-open handle is only meaningful while the drawer is closed and a
     selection exists; otherwise it is redundant with the drawer itself. */
  var n = $(".sample_side-lists").children().length;
  var show = n > 0 && sampleDrawerDismissed;
  $("[data-sample-reopen]").attr("hidden", show ? null : "hidden");
  $("[data-sample-reopen-count]").text(n);
}

function toggleDrawerVisibility() {
  /* RETIRED 2026-08-03 (David: "2 carts open up"). This legacy drawer
     (.simple_drawer-wraper) and the global cart-backed sample tray
     (snippets/sample-tray.liquid) are two panels for one job. Since swatch
     ticks now write straight to the cart, sample-tray's own
     'feydom:sample-added' listener opens the tray -- so leaving this one alive
     meant BOTH slid out on every add.

     The tray wins: it is cart-backed, it is global (PDP popup and
     /pages/barve-in-materiali both), and it already has the "Naroči vzorce"
     checkout step. This function now only guarantees the legacy drawer stays
     shut; the markup is left in place so nothing that queries it throws. */
  $(".simple_drawer-wraper").hide();
  $("body").removeClass("dialog-show");
  $(".sample-reopen").attr("hidden", true).hide();
}

$(document).on("click", "[data-sample-reopen]", function (e) {
  e.preventDefault();
  sampleDrawerDismissed = false;
  toggleDrawerVisibility();
});
// When the user clicks on the "Add to Cart" button
/* Samples are already in the cart by the time this button is visible, so it
   no longer adds anything. It is now the "I am done, take me to checkout"
   step David asked for. The old handler re-posted every sample AND then did
   `window.location.href = "/pages/colors-and-materials"` -- a DE-era handle
   that 301s on this store, so every add ended in a full page load through a
   redirect. That reload is what re-opened the cart and made the flow feel
   broken. */
$(document).on("click", ".multiadd_to-cart", function (e) {
  e.preventDefault();
  window.location.href = "/checkout";
});

$(document).on("change", `[name="sort_by"]`, function () {
  var $el = $(this);
  setTimeout(function () {
    updateFilterAndFetchData();
  }, 1000);
});

$(document).on("click", ".side_loader__close", function (e) {
  e.preventDefault();
  /* Record the dismissal so toggleDrawerVisibility() stops re-opening on the
     next add, and actually hide the wrapper: removing the body class alone
     left .simple_drawer-wraper displayed. */
  sampleDrawerDismissed = true;
  $(".simple_drawer-wraper").hide();
  $("body").removeClass("dialog-show");
  syncSampleReopen();
});
// Check if products are in the cart and update the checkboxes on page load
function checkCartForItems() {
  // Fetch cart contents
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cartData) => {
      // Get all items in the cart
      var cartItems = cartData.items;

      // Loop through each item in the cart and update checkboxes and labels
      $(".formulas_checkboxes").each(function () {
        var $checkbox = $(this);
        var checkboxId = $checkbox.val();

        // Check if this checkbox's value (product ID) is in the cart
        var isInCart = cartItems.some((item) => item.id == checkboxId);

        // If the item is in the cart, check the checkbox and update the label
        if (isInCart) {
          $checkbox.prop("checked", true); // Check the checkbox
          $checkbox
            .parents(".cmcnt--item-prd")
            .find(".label_wrap")
            /* Was the hardcoded English "Added" -- the one label on this page
               that never got translated, so a returning shopper saw "Added"
               under every swatch already in the cart while every other state
               said "Naroči vzorec" / "Odstrani". Matches what the toggle
               handler writes, so the two paths can no longer disagree. */
            .html("Ukloni");
          $checkbox.parents(".prod_Checkbox").addClass("active-checkbox");
          // Optionally, add the item to the sample list
          var itemInCart = cartItems.find((item) => item.id == checkboxId);
          var newSampleHTML = `<div class="samples__list" data-id="${itemInCart.id}">
                                        <div class="samples_list__samples_img">
                                            <img src="${itemInCart.image}" alt="${itemInCart.title}">
                                        </div>
                                        <div class="samples_list__samples_title">${itemInCart.title}</div>
                                        <a href="#" class="remove_samples_from_list">x</a>
                                      </div>`;
          $(".sample_side-lists").append(newSampleHTML);
        }
      });

      // Ensure drawer visibility based on the sample list
      toggleDrawerVisibility();
    })
    .catch((error) => console.error("Error fetching cart data:", error));
}

const formatValue = (value) => (value ? value.replace(/\s/g, "+") : '""');

// Function to construct filter string based on the values of filters and sliders
const buildFilterString = () => {
  // Get values from sliders and inputs
  const length_value = $("#length_slider").val();
  const width_value = $("#width_slider").val();
  const sortVal = $(`[name="sort_by"]:checked`).val() || $("#SortBy").val();
  const numberOfPerson = $("#person_slider").val();

  // Get checkbox values
  const coversChecked = $('[name="covers"]').is(":checked");
  const legChecked = $('[name="legs"]').is(":checked");
  const drawersChecked = $('[name="drawers"]').is(":checked");
  const bed_useChecked = $('[name="bed_use"]:checked')
    .map(function () {
      return $(this).val(); // Get the value of the checked checkbox
    })
    .get();
  // Build the filters array with mandatory values
  // let filters = [
  //   // `filter.p.m.custom.length=${formatValue(length_value)}`,
  //   // `filter.p.m.custom.width=${formatValue(width_value)}`,
  //   // `filter.p.m.custom.number_of_persons=${formatValue(numberOfPerson)}`,
  //   `custom-filter=length:${length_value},width:${width_value},person:${numberOfPerson}`,
  // ];

  let filters = [
    // `filter.p.m.custom.length=${formatValue(length_value)}`,
    // `filter.p.m.custom.width=${formatValue(width_value)}`,
    // `filter.p.m.custom.number_of_persons=${formatValue(numberOfPerson)}`
  ];

  if (length_value != null && width_value != null && numberOfPerson != null) {
    filters.push(
      `custom-filter=length:${length_value},width:${width_value},person:${numberOfPerson}`
    );
  }

  if (!filters.length) {
    return "";
  }

  $("#width_slider_value").val(width_value);
  $("#length_slider_value").val(length_value);
  $("#person_slider_value").val(numberOfPerson);
  // Add filters based on checkbox states
  if (coversChecked) {
    const covers = $('[name="covers"]').val();
    filters.push(`filter.p.m.custom._removable_covers=${formatValue(covers)}`);
  }

  if (legChecked) {
    const legs = $('[name="legs"]').val();
    filters.push(`filter.p.m.custom.legs=${formatValue(legs)}`);
  }

  if (drawersChecked) {
    const drawers = $('[name="drawers"]').val();
    filters.push(
      `filter.p.m.custom._additional_storage_spaces=${formatValue(drawers)}`
    );
  }
  if (bed_useChecked.length > 0) {
    filters.push(`filter.p.m.custom.bed_use=${bed_useChecked}`); // Join values with comma
  }
  // Always add 'sort_by' at the end of the filter array
  filters.push(`sort_by=${sortVal ? encodeURIComponent(sortVal) : '""'}`);

  return filters.join("&");
};

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// Function to update the URL and fetch data
const updateFilterAndFetchData = () => {
  // Build the filter string
  const filterString = buildFilterString();
  if (filterString == "") {
    return;
  }

  // Construct the final URL (no view=custom-collection parameter)
  const new_link = `${window.location.pathname}?${filterString}&view=ajax`;
  const window_new_link = `${window.location.pathname}?${filterString}`;

  // Update the browser URL without reloading the page
  window.history.pushState(null, "", window_new_link);

  setTimeout(function () {
    // Fetch the filtered data
    getDataWithType(new_link, "text")
      .then((html) => {
        const doc = document.createElement("div");
        doc.innerHTML = html;
        const target = doc.querySelector(".template--collection--ajax11");
        const innerContent = target ? target.innerHTML : ""; // Ensure target exists

        // Update the DOM with the new content
        $(".custom-template--collection--ajax").html(innerContent);
        var custom_filter = getParameterByName("custom-filter");
        const parsedValues = parseParameters(custom_filter);

        const griditemss = $("#product-grid li").filter(function () {
          return (
            $(this).attr("person_q") >= parsedValues.person &&
            $(this).attr("length_q") <= parsedValues.length &&
            $(this).attr("width_q") <= parsedValues.width
          );
        });

        // Hide all items, then directly show the filtered ones
        $("#product-grid li").hide();
        griditemss.show();

        $("#ProductCountDesktop").html(
          `${$(target).find("li").length} products`
        );
      })
      .catch((error) => {
        console.error("Error fetching data:", error); // Log any error in the request
      });
  }, 0);
};

function parseParameters(paramString) {
  // Split the string into key-value pairs
  const pairs = paramString.split(",");

  // Convert pairs into an object
  const result = {};
  pairs.forEach((pair) => {
    const [key, value] = pair.split(":");
    result[key] = isNaN(value) ? value : Number(value); // Convert numeric values
  });

  return result;
}

// Attach the optimized function to all sliders
$("#length_slider, #width_slider, #person_slider").on(
  "input",
  updateFilterAndFetchData
);

// Attach the optimized function to all checkboxes
$('[name="covers"], [name="legs"], [name="drawers"]').click(
  updateFilterAndFetchData
);
$('[name="bed_use"]').on("change", updateFilterAndFetchData);
// if ($("body").attr("data-template") == "collection") updateFilterAndFetchData();

async function getDataWithType(url = "", type = "json") {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    switch (type) {
      case "json":
        return response.json();
      case "text":
        return response.text();
      default:
        throw new Error(`Unsupported type: ${type}`);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error; // Re-throw to allow further handling if necessary
  }
}

window.addEventListener("load", () => {
  /* The scroll zoom on the video section is gone (David 2026-08-07: "delete
     this zoom in"). It scaled .custom-video-wrap up to 1.13 from its centre
     while pinning it sticky, and because that wrap is overflow: hidden, the
     scaled-up heading was pushed past the top edge and sliced in half -- the
     "text is behind section" symptom. Nothing replaces it; the section is a
     plain block now. */

  // $(".vc--video").click(function () {
  //   this.paused ? this.play() : this.pause();
  // });

  // checkForOOSMessage();
});

$(".thumbnail-list_item--variant").eq(0).show();
$(".thumbnail-list_item--variant").eq(1).show();

window.onVariantChange = (variant) => {
  var variant_sku = image_alt = "";
  if (variant) {
    variant_sku = variant.sku;
    image_alt = variant.featured_media ? variant.featured_media.alt : "";
  }

  $(".prd__sku").text(variant_sku);
  setTimeout(function () {
    $(".thumbnail-list_item--variant").eq(0).show();
  }, 1);

  // Use the toggleCustomAttrWrapElements function to handle visibility and selection
  // This ensures consistent behavior when variants change
  toggleCustomAttrWrapElements();
};


document.querySelectorAll('#Search-In-Modal').forEach(function(input) {
  input.addEventListener('input', function () {
    const form = this.closest('.search-modal__form');
    const label = form ? form.querySelector('.field__label') : null;

    if (this.value.trim() !== '') {
      this.removeAttribute('placeholder');
      if (label) label.style.display = 'none';
    } else {
      if (label) label.style.display = '';
    }
  });
});

window.checkAvailability = () => {
  checkForOOSMessage();
}

function checkForOOSMessage() {
  let isAvailable = true;
  Array.from(document.querySelectorAll('select option[selected], fieldset input:checked')).some(
    (el) => {
      if (el.offsetParent !== null && getComputedStyle(el).visibility !== "hidden" && el.clientHeight > 0 && el.clientWidth > 0) {
        if (el.closest('.custom_attr_wrap') && el.closest('.custom_attr_wrap').dataset.avl == "false" && el.classList.contains('swatch-input__input')) {
          isAvailable = false;
        }
      }
    }
  );
  
  if (isAvailable) {
    $(".out-of-stock-selected").hide();
  } else {
    $(".out-of-stock-selected").show();
  } 
}

/* ---------------------------------------------------------------------------
   FEYDOM card: seat the corner arrow into the price row.

   The round black go-button is markup a card's CALLER prints, as a sibling of
   the card, because `feydom-card-styles` positions it against the <li>. The
   design puts it on the price line, level with the figure, and the only way to
   get it there is to move it into Dawn's price block once that block exists.

   home-product-slider and product-other-models each shipped their own copy of
   this loop, scoped to their own section. From 2026-09-03 the same card is used
   by the collection grid, search, related products, the wishlist and the
   from-stock grid, so the loop is document-wide and lives here instead. It is
   idempotent (`price.contains(go)` bails), so the two section-level copies can
   keep running without moving anything twice.

   The observer is for the collection grid: filtering and sorting swap
   #ProductGridContainer's innerHTML, and the freshly injected cards arrive with
   the arrow back outside the price row.
   ------------------------------------------------------------------------ */
(function () {
  function seatFeydomCardArrows(root) {
    (root || document).querySelectorAll('.fey-card__go').forEach(function (go) {
      var card = go.closest('li') || go.parentElement;
      if (!card) return;
      var price = card.querySelector('.card__information .price');
      if (!price || price.contains(go)) return;
      price.appendChild(go);
      card.classList.add('fey-go--inline');
    });
  }
  window.seatFeydomCardArrows = seatFeydomCardArrows;

  function boot() {
    seatFeydomCardArrows(document);
    /* Two containers fill themselves in after load and have to be watched:
       #ProductGridContainer, whose innerHTML the filter/sort swaps, and
       #wishlist-container, which wishlist.js fills one fetched card at a
       time -- at DOMContentLoaded it holds nothing but "loading". */
    ['ProductGridContainer', 'wishlist-container'].forEach(function (id) {
      var grid = document.getElementById(id);
      if (!grid || !window.MutationObserver) return;
      /* Re-entrancy guard: seating an arrow is itself a childList mutation
         inside the observed subtree, so without the flag the observer would
         re-fire on its own work. One extra pass would terminate anyway (the
         second pass finds nothing to move), but the flag keeps the callback
         off the hot path while a 46-card grid is being replaced. */
      var seating = false;
      new MutationObserver(function () {
        if (seating) return;
        seating = true;
        seatFeydomCardArrows(grid);
        seating = false;
      }).observe(grid, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
